import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

// Get available models for current user based on team permissions
export const fetchAvailableModels = async () => {
  const response = await fetch(`${API_BASE_URL}/api/models`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch available models');
  }
  
  return response.json();
};

// Refresh models cache (admin only)
export const refreshModelsCache = async () => {
  const response = await fetch(`${API_BASE_URL}/api/models/refresh`, {
    method: 'POST',
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to refresh models cache');
  }
  
  return response.json();
};

// Transform models data for UI components
export const transformModelsForUI = (modelsData) => {
  const allModels = [];
  
  // Add OpenAI models
  if (modelsData.openai) {
    modelsData.openai.forEach(model => {
      allModels.push({
        ...model,
        provider: 'openai',
        providerName: 'OpenAI'
      });
    });
  }
  
  // Add Anthropic models
  if (modelsData.anthropic) {
    modelsData.anthropic.forEach(model => {
      allModels.push({
        ...model,
        provider: 'anthropic',
        providerName: 'Anthropic'
      });
    });
  }
  
  // Add Google models
  if (modelsData.google) {
    modelsData.google.forEach(model => {
      allModels.push({
        ...model,
        provider: 'google',
        providerName: 'Google'
      });
    });
  }
  
  return allModels;
};

// Get models grouped by provider
export const getModelsByProvider = (modelsData) => {
  return {
    openai: modelsData.openai || [],
    anthropic: modelsData.anthropic || [],
    google: modelsData.google || []
  };
};

// Get global models settings (admin only)
export const fetchGlobalModelsSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/api/models/global`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch global models settings');
  }
  
  return response.json();
};

// Update global models settings (admin only)
export const updateGlobalModelsSettings = async (settings) => {
  const response = await fetch(`${API_BASE_URL}/api/models/global`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(settings),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update global models settings');
  }
  
  return response.json();
};

// Get top models for frontend (all users)
export const fetchTopModels = async () => {
  const response = await fetch(`${API_BASE_URL}/api/models/top/public`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch top models');
  }
  
  return response.json();
};

// Get top models settings (admin only)
export const fetchTopModelsSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/api/models/top`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch top models settings');
  }
  
  return response.json();
};

// Update top models settings (admin only)
export const updateTopModelsSettings = async (settings) => {
  const response = await fetch(`${API_BASE_URL}/api/models/top`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(settings),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update top models settings');
  }
  
  return response.json();
};